(() => {
  const registered = new Map();
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const setToggle = (button, paused) => {
    button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
    button.setAttribute('aria-pressed', String(paused));
    button.querySelector('[data-bhb-pause-icon]').hidden = paused;
    button.querySelector('[data-bhb-play-icon]').hidden = !paused;
  };
  const setupRoutine = (element) => {
    const words = Array.from(element.querySelectorAll('[data-bhb-routine-word]'), node => node.dataset.bhbRoutineWord).filter(Boolean);
    const live = element.querySelector('[data-bhb-routine-live]');
    const button = element.querySelector('[data-bhb-routine-toggle]');
    if (!words.length || !live || !button) return () => {};
    let index = 0;
    let length = words[0].length;
    let deleting = false;
    let paused = false;
    let timer;
    const paint = () => { live.textContent = words[index].slice(0, length); };
    const schedule = () => {
      window.clearTimeout(timer);
      const running = !motion.matches && !document.hidden && !paused && words.length > 1;
      element.dataset.animating = String(running);
      button.hidden = motion.matches || words.length < 2;
      if (!running) return;
      const delay = deleting ? (length === 0 ? 300 : 55) : (length === words[index].length ? 2200 : 105);
      timer = window.setTimeout(() => {
        if (deleting) {
          if (length === 0) { index = (index + 1) % words.length; deleting = false; }
          else length -= 1;
        } else if (length === words[index].length) deleting = true;
        else length += 1;
        paint();
        schedule();
      }, delay);
    };
    const preferenceChanged = () => {
      if (motion.matches) { index = 0; length = words[0].length; deleting = false; paint(); }
      schedule();
    };
    const toggle = () => { paused = !paused; setToggle(button, paused); schedule(); };
    button.addEventListener('click', toggle);
    motion.addEventListener('change', preferenceChanged);
    document.addEventListener('visibilitychange', schedule);
    paint();
    schedule();
    return () => {
      window.clearTimeout(timer);
      button.removeEventListener('click', toggle);
      motion.removeEventListener('change', preferenceChanged);
      document.removeEventListener('visibilitychange', schedule);
    };
  };
  const setupMarquee = (element) => {
    const button = element.querySelector('[data-bhb-marquee-toggle]');
    if (!button) return () => {};
    let paused = false;
    const sync = () => {
      element.dataset.paused = String(paused || document.hidden || motion.matches);
      button.hidden = motion.matches;
      setToggle(button, paused);
    };
    const toggle = () => { paused = !paused; sync(); };
    element.dataset.bhbReady = 'true';
    button.addEventListener('click', toggle);
    motion.addEventListener('change', sync);
    document.addEventListener('visibilitychange', sync);
    sync();
    return () => {
      button.removeEventListener('click', toggle);
      motion.removeEventListener('change', sync);
      document.removeEventListener('visibilitychange', sync);
    };
  };
  const setupCarousel = (element) => {
    const track = element.querySelector('[data-bhb-carousel-track]');
    const controls = element.querySelector('[data-bhb-carousel-controls]');
    if (!track || !controls) return () => {};
    const previous = controls.querySelector('[data-bhb-carousel-direction="-1"]');
    const next = controls.querySelector('[data-bhb-carousel-direction="1"]');
    if (!previous || !next) return () => {};
    const update = () => {
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollWidth - track.clientWidth - track.scrollLeft <= 2;
    };
    const scroll = (event) => {
      const button = event.target.closest('[data-bhb-carousel-direction]');
      if (!button || button.disabled) return;
      const gap = Number.parseFloat(window.getComputedStyle(track).columnGap) || 0;
      const step = (track.firstElementChild?.getBoundingClientRect().width || track.clientWidth) + gap;
      track.scrollBy({ left: Number(button.dataset.bhbCarouselDirection) * step, behavior: motion.matches ? 'instant' : 'smooth' });
    };
    let observer;
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(update);
      observer.observe(track);
      for (const item of track.children) observer.observe(item);
    } else window.addEventListener('resize', update);
    track.addEventListener('scroll', update, { passive: true });
    controls.addEventListener('click', scroll);
    controls.hidden = false;
    update();
    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', update);
      track.removeEventListener('scroll', update);
      controls.removeEventListener('click', scroll);
    };
  };
  const init = (scope) => {
    for (const [selector, setup] of [['[data-bhb-routine]', setupRoutine], ['[data-bhb-home-marquee]', setupMarquee], ['[data-bhb-home-carousel]', setupCarousel]]) {
      const elements = Array.from(scope.querySelectorAll(selector));
      if (scope.matches?.(selector)) elements.unshift(scope);
      for (const element of elements) if (!registered.has(element)) registered.set(element, setup(element));
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [element, cleanup] of registered) if (element === event.target || event.target.contains(element)) { cleanup(); registered.delete(element); }
  });
})();
